export function Contact() {
    return         <section className="py-1 text-light">
            <div className="container">
                <div className="row" style={{height: "100px"}}></div>
                <div className="row justify-content-left">
                    <div className="col-lg-7 justify-content-center">
                        <h1>Contact</h1>
                        <p className="lead">
                            Please email <a href="mailto:info@isentropy.com">info@isentropy.com</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>

}